@use "variables" as *;

.content {
  display: flex;
  flex-direction: column;
}

.paymentStack {
  margin-bottom: $spacing-xg;
}

.paymentStatus {
  font-size: $fontSize-s;
  margin-right: $spacing-s;
}

.date {
  font-size: $fontSize-s;
  font-weight: bolder;
}

.manageButton {
  width: 100%;
  margin: 0 $spacing-m $spacing-m $spacing-m;
}
